module.exports = __webpack_public_path__ + "static/media/img3.d0404010.svg";